module.exports = __webpack_public_path__ + "img/observa-logo.81120758.png";